<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex-1 min-w-0 flex flex-col gap-0.5">
            <div class="body-semibold text-valence-stone-900 truncate">{{ cycle.template.name }}</div>
            <div class="scaffold-body-small text-valence-stone-500">
                <template v-if="kind === 'sixty'"> {{ cycle.responded_count }} of {{ Math.max(cycle.total_invited, 1) }} responses recorded </template>
                <template v-else>Completed reflection</template>
            </div>
            <div v-if="dateLabel" class="scaffold-body-small text-valence-stone-500">{{ dateLabel }}</div>
        </div>
        <a
            v-if="cycle.has_report"
            :href="`/reflections/360/${cycle.id}/results`"
            class="base-btn-neutral base-btn-square base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            @click.prevent="emit('view', cycle.id)">
            View Results
        </a>
        <!-- No report and `unlocked_at` is set → aggregation is legitimately in
             flight (seconds for self-only, minutes for 360). No report and
             `unlocked_at` is null → cycle was closed without meeting the
             minimum-responses threshold, so no report will ever be generated. -->
        <button
            v-else-if="cycle.unlocked_at"
            type="button"
            class="base-btn-neutral base-btn-square base-btn-sm shrink-0 whitespace-nowrap opacity-60 pointer-events-none flex items-center gap-1.5">
            <i class="bi bi-arrow-repeat animate-spin" aria-hidden="true"></i>
            Generating…
        </button>
        <span v-else class="details text-valence-stone-500 sm:shrink-0 sm:self-center">Closed without a report</span>
    </BaseCard>
</template>

<script setup lang="ts">
import type { PastCycleSummary } from "~vue/api/generated/reflections";
import BaseCard from "~vue/components/BaseCard.vue";
import { formatDate } from "~vue/utils/threeSixty";
import { computed } from "vue";

interface Props {
    cycle: PastCycleSummary;
    kind: "sixty" | "self";
}

const { cycle } = defineProps<Props>();
const emit = defineEmits<{ (event: "view", cycleId: string): void }>();

const dateLabel = computed(() => formatDate(cycle.unlocked_at || cycle.closed_at, "long"));
</script>
